// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"eM-z","carouselContainer":"fM-z"};